import throttle from 'raf-throttle';

class PanelCollapse extends HTMLElement {
  constructor() {
    super();
    this.isInit = false;
    this.isActive = false;
    this.defaultOpen = this?.dataset?.defaultOpen ?? false;
    this.$toggleBtn = this.querySelector('.panel-collapse__toggle-btn');
    this.$content = this.querySelector('.panel-collapse__content');
    this.disableAtViewport = this?.dataset?.disableSize ?? false;
    if (this.$toggleBtn && this.$content) this.setupEventListeners();
    if (this.disableAtViewport) {
      this.monitorViewport();
    } else {
      this.initPanel();
    }
  }

  destroy() {
    if (!this.isInit) return;
    this.showPanel();
    this.classList.remove('panel-collapse--is-init');
    this.isInit = false;
  }

  initPanel() {
    if (this.isInit) return;
    this.classList.add('panel-collapse--is-init');
    this.isInit = true;
    if (this.defaultOpen) {
      this.showPanel();
    } else {
      this.hidePanel();
    }
  }

  checkViewport() {
    const disableSize = parseInt(this.disableAtViewport, 10);
    const viewportWidth = window.innerWidth;
    if (viewportWidth < disableSize) {
      this.initPanel();
    } else {
      this.destroy();
    }
  }

  monitorViewport() {
    // Run on init
    this.checkViewport();
    const throttled = throttle(() => {
      this.checkViewport();
    });
    // Run on viewport resize
    window.addEventListener('resize', throttled);
  }

  showPanel() {
    this.classList.add('panel-collapse--is-active');
    this.isActive = true;
    this.$content.setAttribute('aria-hidden', false);
  }

  hidePanel() {
    this.classList.remove('panel-collapse--is-active');
    this.isActive = false;
    this.$content.setAttribute('aria-hidden', true);
  }

  togglePanel() {
    if (this.isActive) {
      this.hidePanel();
    } else {
      this.showPanel();
    }
  }

  setupEventListeners() {
    this.$toggleBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.togglePanel();
    });
  }
}

export default function init() {
  customElements.define('panel-collapse', PanelCollapse);
}
